import axios from 'axios';

const factory = {
  personobject: function (id, map = false) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/factory/personobject/${id}?map=${map}`)
        .then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
    });
  },
  freetext: function (string) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
        },
        url: '/api/factory/fullname/',
        data: {
          params: string,
        },
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  }
}

export default factory;




